// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9e35ff2c","239":"6f11c3d1","453":"8ced0566","732":"f58c68cd","879":"34527e54"}[chunkId] + ".chunk.js";
};